import { FC, ReactElement, ReactNode } from 'react'

import { Tooltip } from '@mui/material'

import { useStyles } from 'components/common/tooltips/styles'

interface IProps {
    title: string
    placement?: 'bottom' | 'left' | 'right' | 'top' | undefined
    arrow?: boolean
    children: ReactNode | ReactElement
}

const BlackTooltip: FC<IProps> = ({ title, placement, arrow, children }) => {
    const style = useStyles()

    return (
        <Tooltip classes={{ tooltip: style.tooltip, arrow: style.arrow }} title={title} placement={placement} arrow={arrow}>
            {children as any}
        </Tooltip>
    )
}

export default BlackTooltip
